
import React, { FC, useState, useEffect } from 'react'
import { KTSVG } from '../../../../_metronic/helpers'
import * as a from '../'

type Props = {
    id?: any
    className?: string
}

export const AncientTable: React.FC<Props> = ({ id, className, children }) => {

    return (
        <table id={id} className={"table align-middle table-row-dashed fs-6 gy-5 gs-7 dataTable no-footer table-striped " + className} role="table">
            {children}
        </table>
    )
}